// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageSelectionSlide_container__1p-EC","header":"LandingPageSelectionSlide_header__3W_lG"};